<div class="modal-header">
  <h4 class="modal-title">
    {{ mode === AddArticleToCollectionMode.SINGLE ? ('addArticleToArticleCollectionPopup.title' | translate) : ('editArticleNumberMappingPopup.label.addToSomeLibrary' | translate) }}
  </h4>
</div>
<div class="modal-body pt-0">
  <div class="modal-body-inner">
    <div class="row">
      <div class="col-sm-6 align-items-center ">
        <img *ngIf="mode === AddArticleToCollectionMode.SINGLE" (error)="handleMissingImage($event)" class="article-image" [src]="articleImage"/>
        <div *ngIf="mode === AddArticleToCollectionMode.SINGLE">
          <label class="mt-0_5">{{'addArticleToArticleCollectionPopup.label.article_number' | translate}}: {{articles[0]?.articleNo}}</label>
        </div>
        <div *ngIf="displayAllArticleNos">
          <label *ngFor="let article of articles" class="mt-0_5">{{'addArticleToArticleCollectionPopup.label.article_number' | translate}}:{{article.articleNo}}</label>
        </div>
      </div>
      <div class="col-sm-6">
        <div class="mb-3 row">
          <label class="col-md-4 col-form-label">
            {{'addArticleToArticleCollectionPopup.label.available_article_collections' | translate}}
          </label>
          <div class="col-md-8">
            <select [(ngModel)]="selectedArticleCollection" class="form-control">
              <option *ngFor="let articleCollection of articleCollections"
                      [ngValue]="articleCollection">{{getArticleCollectionLabel(articleCollection.name)}}
              </option>
            </select>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="modal-footer">
  <button class="btn btn-secondary btn-cancel"
          type="button"
          (click)="close()"
          id="closeButton">
    {{'global.label.cancel' | translate}}
  </button>
  <button class="btn btn-primary btn-forward"
          type="submit"
          (click)="add()"
          id="addArticleButton"
          [disabled]="!selectedArticleCollection">
    {{'addArticleToArticleCollectionPopup.label.add' | translate}}
  </button>
</div>
